import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "@mui/material";
export const UiCheckboxV2 = (props) => (_jsx(Checkbox, Object.assign({}, props)));
//# sourceMappingURL=ui_checkbox_v2.js.map